<template>
  <div>
    <div>
      <h4 class="heading">Изберете метод на плащане:</h4>
      <div
        v-if="paymentGateways.length == 0"
        class="no-payment-gateways"
      >
        Събитието не е в продажба.
      </div>
      <div
        v-for="item in paymentGateways"
        class="payment-gateway-selector"
        :class="{ selected: selectedGateway.type === item.type }"
        @click="selectedGateway = item"
      >
        <v-icon
          class="icon"
          color="primary"
        >
          checkbox
        </v-icon>
        <div class="name">{{ item.title }}</div>
        <div class="description">
          {{ item.description }}
        </div>
        <div class="price">
          {{ getServiceFeeForGateway(item) }} {{ currency }}
        </div>
      </div>
    </div>
    <div class="total">
      <h4>Общо:</h4>
      <div class="total-fee">
        <template v-if="selectedGateway.type">
          <span class="numbers">{{ totalPrice }} {{ currency }}</span>
        </template>
        <template v-else>-- изберете метод за плащане --</template>
      </div>
    </div>

    <paypal
      v-if="selectedGateway.type === 'paypal'"
      :event="event"
      :gateway-settings="selectedGateway"
      :secret="secret"
      @step-change="(val) => this.$emit('step-change', val)"
      :selected-tickets="selectedTickets"
    />
    <raiffeisen
      v-if="selectedGateway.type === 'raiffeisen'"
      :event="event"
      :gateway-settings="selectedGateway"
      :secret="secret"
      :selected-tickets="selectedTickets"
    />
    <epay-gateway
      v-if="selectedGateway.type === 'epay'"
      :event="event"
      :secret="secret"
    ></epay-gateway>
    <dsk-gateway
      v-if="selectedGateway.type === 'dsk'"
      :event="event"
      :secret="secret"
    ></dsk-gateway>
  </div>
</template>

<script>
import Paypal from './Gateways/Paypal'
import Raiffeisen from './Gateways/Raiffeisen'
import EpayGateway from './Gateways/EpayGateway'
import DskGateway from './Gateways/DskGateway.vue'

export default {
  name: 'GatewayList',
  props: {
    event: {
      type: Object,
      required: true,
    },
    secret: {
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    amount: {
      required: true,
    },
    selectedTickets: {
      type: Array,
      required: true,
    },
  },
  components: {
    DskGateway,
    EpayGateway,
    Paypal,
    Raiffeisen,
  },
  watch: {
    selectedGateway: {
      handler(val) {
        this.$emit('gateway-change', val)
      },
      deep: true,
    },
  },
  computed: {
    paymentGateways() {
      if (
        this.event.enabled_payment_gateways &&
        this.event.enabled_payment_gateways.length > 0
      ) {
        return this.event.enabled_payment_gateways
      }

      return []
    },
    totalPrice() {
      let serviceFee = this.getServiceFeeForGateway(this.selectedGateway)

      const sum = this.amount + serviceFee
      return parseFloat(sum).toFixed(2)
    },
  },
  data() {
    return {
      selectedGateway: {},
    }
  },
  methods: {
    getServiceFeeForGateway(gateway) {
      let serviceFee = 0

      if (gateway.service_fee_type === 'fixed') {
        if (gateway.service_fee_application === 'per-ticket') {
          serviceFee = (gateway.service_fee / 100) * this.selectedTickets.length
        } else {
          serviceFee = gateway.service_fee / 100
        }
      } else {
        serviceFee = (gateway.service_fee / 100) * this.amount
      }

      return serviceFee
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
.heading {
  margin-top: 20px;
}

.payment-gateway-selector {
  text-align: center;
  font-size: 18px;
  border: 2px solid #82b6eb54;
  padding: 10px 10px 10px 10px;
  border-radius: 4px;
  background: #faf8ffe8;
  margin-top: 10px;
  font-weight: bold;
  color: #293470;
  cursor: pointer;
  display: flex;

  transition: all 0.2s ease-in;
  align-content: center;

  @media all and (max-width: 500px) {
    flex-direction: column;
  }

  &.selected {
    padding: 10px 10px 10px 45px;
  }

  .icon {
    position: absolute;
    left: 30px;
    opacity: 0;
  }

  &.selected .icon {
    opacity: 1;
  }

  .name {
    flex: 1;
    max-width: 150px;
  }

  .description {
    font-size: 16px;
    font-weight: normal;
    color: gray;
    flex: 1;
  }

  .price {
    display: flex;
    align-items: center;
  }
}

.total {
  margin-top: 20px;
  text-align: right;
  margin-bottom: 50px;

  h4 {
    color: #293470;
    display: inline;
  }

  .total-fee {
    display: inline-block;
    width: 100%;
    max-width: 220px;
    text-align: right;
  }

  .numbers {
    color: #293470;
    font-size: 24px;
    font-weight: bold;
  }
}

.no-payment-gateways {
  text-align: center;
  font-size: 18px;
  border: 2px solid #eb1000;
  padding: 10px;
  border-radius: 4px;
  background: #f7f7f7e8;
  color: #f92929;
  font-weight: bold;
}
</style>
